import { toast } from 'react-toastify';

import { useMutation } from '@tanstack/react-query';
import { pendingAffiliateService } from 'v2/services/affiliate/pendingAffiliate';

const MODERATE_ERROR_MESSAGE = 'Erro ao alterar status dos afiliado';

export const useModerateAffiliate = () => {
  const { mutateAsync: moderateAffiliate, isPending: isModerateAffiliatePending } = useMutation({
    mutationFn: ({ affiliateId, status }: { affiliateId: number; status: 'A' | 'R' }) => {
      return pendingAffiliateService.moderateAffiliate(affiliateId, status);
    },
    onError: (error: unknown) => {
      toast.error(typeof error === 'string' ? error : MODERATE_ERROR_MESSAGE);
    }
  });

  return {
    moderateAffiliate,
    isModerateAffiliatePending
  };
};
